import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RichTextViewComponent } from 'shared/feature-rich-text-view';
import { IconDirective, ButtonDirective } from 'shared/ui-common';

import { GuidelineActionDto } from '@treetop/shared/model';

export type MedicationRequest = GuidelineActionDto;

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-medication-card',
  templateUrl: './medication-card.component.html',
  styleUrls: ['./medication-card.component.scss'],
  imports: [RichTextViewComponent, IconDirective, MatIconModule, ButtonDirective],
})
export class MedicationCardComponent {
  public medication = input.required<MedicationRequest>();

  public editClicked = output<void>();
  public deleteClicked = output<void>();
}
